import en, { TranslationMessages } from './en';
import flattenMessages from '@liveauctioneers/caterwaul-components/lib/utils/flattenMessages';

/* eslint-disable sort-keys/sort-keys-fix, max-len */
const nl: TranslationMessages = {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: 'Inloggen om te Bieden',
                signup: 'Aanmelden om te Bieden',
                register_long: 'Registreer voor Veiling',
                pending: 'Registratie is in Behandling',
                declined: 'Registratie is Geweigerd',
                closed: 'Kavel Gesloten',
                sent: 'Uw bod is verzonden',
                outbid: 'U bent Overboden, Biedt {amount}',
                bid: 'Bied {amount}',
                winning: 'U bent aan het Winnen',
                // needed
                addPaymentMethod: 'Betaling Toevoegen om Bod te Plaatsen',
                approved_limited: 'U bent goedgekeurd om tot {limit} te bieden, en heeft nog {balance} over.',
                backToLiveItem: 'Terug naar Huidige Kavel',
                bidding_locked: 'Bieden Vergrendeld',
                bidding_unlocked: 'Bieden Ontgrendeld',
                hide_settings: 'Instellingen Verbergen',
                limit_exceeded: 'Dit item zou uw bodlimiet van {limit} overschrijden',
                show_settings: 'Toon Instellingen',
                suspended: 'Account Opgeschort',
                waiting: 'Wacht u nog steeds op goedkeuring?',
            },
            // needed
            currentLiveItem: {
                auctioneerInfo: {
                    buttons: {
                        askAQuestion: 'Vraag Stellen',
                        follow: 'Volg',
                        following: 'Volgt',
                        followingAuctioneer: 'Volgt Veilinghuis',
                        followAuctioneer: 'Volg Veilinghuis',
                    },
                },
                buyersPremium: {
                    middleLowCutOff: '{middle}% hierboven',
                    middleCutOff: '{middle}% tot',
                    highCutOff: '{high}% hierboven',
                    lowCutOff: '{low}% tot',
                    lowPercentage: '{low}%',
                },
                curator: {
                    curatedBy: 'Veiling Samengesteld Door',
                },
                headers: {
                    buyersPremium: 'Koperspremie',
                    condition: 'Staat',
                    description: 'Beschrijving',
                    dimensions: 'Dimensies',
                    itemDetails: 'Item Details',
                    weight: 'Gewicht',
                },
            },
            conversions: {
                lot_number: 'Kavel {lotNumber}',
            },
            description: {
                estimate_range: 'Geschat {low} - {high}',
                images_label: '{currentImageNumber} / {totalImages}',
                // needed
                single_estimate: 'Est. {number}',
                currentBid: 'Current Bid: {amount}',
                convertedBid: 'Conversion: {amount}',
            },
            // needed
            lotTracker: {
                bid: 'Bied',
                bids: 'Biedingen',
                liveNow: 'Nu Live',
                soldFor: 'Verkocht voor',
                passed: 'Gepasseerd',
            },
            messages: {
                ask_price_changed_to: 'Ask Price Changed: {amount}{converted}',
                competing_bid_amount: '{amount}{converted}: Concurrerend Bod',
                competing_bidder_outbid_by_liveauctioneers_absentee:
                    'Concurrerende Bieder werd door het bod van Bieder {paddleNumber} bij Afwezigheid Overboden',
                last_bid_retracted: 'Laatste bod van {amount}{converted} is ingetrokken',
                liveauctioneers_bid_amount: '{amount}{converted}: LiveAuctioneers Bieder {paddleNumber}',
                liveauctioneers_bid_amount_absentee:
                    '{amount}{converted}: LiveAuctioneers Bieder {paddleNumber} bod bij Afwezigheid',
                lot_number_passed: 'Kavel {lotNumber} Gepasseerd',
                lot_number_reopened: 'Kavel {lotNumber} Opnieuw Geopend',
                lot_number_skipped: 'Kavel {lotNumber} Overgeslagen',
                lot_number_unsold: 'Kavel {lotNumber} Niet Verkocht',
                lot_opened_asking: 'Kavel {lotNumber} Geopend – Vraag {amount}{converted}',
                lot_sold_competing_bidder:
                    'Kavel {lotNumber} verkocht voor {amount}{converted} aan Concurrerende Bieder',
                lot_sold_liveauctioneers_bidder:
                    'Kavel {lotNumber} verkocht voor {amount}{converted} aan Bieder {paddleNumber}',
                my_bid_amount: '{amount}{converted}: Mijn Bod',
                my_bid_amount_absentee: '{amount}{converted}: Mijn Bod bij Afwezigheid',
                my_bid_retracted: 'Uw bod voor {amount}{converted} werd ingetrokken',
                registration_approved: 'Uw registratie is goedgekeurd',
                reserve_not_met: 'Reserve is niet behaald',
                you_been_outbid_by_liveauctioneers_absentee:
                    'U bent door het bod van Bieder {paddleNumber} bij Afwezigheid Overboden',
                you_ve_won_lot: 'U hebt Kavel {lotNumber} gewonnen',
                // needed
                bid_limit_exceeded: 'Uw bodlimiet is overschreden',
                limited_approval: 'Goedgekeurd om te bieden tot: {limit}',
                paused: 'Veiling Onderbroken',
            },
            // needed
            settingsMenu: {
                headerText: 'Instellingen',
                language: 'Taal',
                currency: 'Valuta',
            },
            missives: {
                fair_warning_lot_about_to_close: 'Waarschuwing... Deze kavel gaat bijna sluiten',
                going_once_going_twice: 'EENMAAL... ANDERMAAL...',
                third_and_final_warning: 'DERDE EN LAATSTE WAARSCHUWING...',
            },
            status: {
                remaining: '{remaining} van de {total} Kavels Resterend',
                // needed
                nextBid: {
                    text: 'Mijn Volgende Bod',
                    value: '{total} Weg',
                },
                nextFavorite: {
                    text: 'Mijn Volgende Favoriet',
                    value: '{total} Weg',
                },
            },
            thumbnail_scroller: {
                next: 'Volgende Kavels',
            },
            // needed
            lockText: {
                locked: 'Ontgrendelen om te Bieden',
                unlocked: 'Bieden Ontgrendeld',
            },
            mobileHeader: {
                title: '{lotNumber}: {title}',
            },
            mobileFooter: {
                itemSaves: '{savedCount}',
            },
        },
        // needed
        explainer_modal: {
            title: 'Welkom op de Veiling',
            subtext: 'Veel geluk! Bekijk enkele veilingdetails.',
            fee_disclaimer:
                'De prijs van uw bod is exclusief mogelijke kosten, zoals een koperspremie, belastingen, verzendkosten of verwerkingskosten',
            autopay_disclaimer: 'Kort na het sluiten van de veiling wordt u de volledige prijs in rekening gebracht',
            shipping_disclaimer:
                'Verzendgegevens zijn te vinden in het verzend-, betalings- en veilingbeleid van deze veiling',
            button: 'Ik heb het begrepen',
        },
        wait: {
            title: 'Blijf kijken. Veiling start binnenkort',
            status_message: '{name} is blij dat u hier bent!',
            login_button_text: 'Log In',
            register_button_text: 'Aanmelden voor Veiling',
            image_slider_text: 'Populaire kavels in deze Veiling',
            hidden_text: 'Bekijk de Catalogus',
            card: {
                title: 'Kavel {lotNumber}: {title}',
                bid: 'Bied',
                bids: 'Biedingen',
            },
        },
        done: {
            title: '{title} is afgelopen',
            status_message: 'Volg {name} om te horen over hun volgende veilingen.',
            live_catalogs_title: 'Bekijk Andere Live Veilingen',
            upcoming_catalogs_title: 'Aankomende Veilingen',
        },
    },
};

export default { ...en, ...flattenMessages(nl) };
